// Ссылка на api -> https://swiperjs.com/swiper-api#swiper-full-html-layout
import Swiper, {  Mousewheel, FreeMode, Navigation } from 'swiper';


const swiper = new Swiper(".slider", {

    modules: [
        Mousewheel,
        FreeMode,
        Navigation
    ],

    wrapperClass: 'slider__wrapper',
    slideClass: 'speaker',
    slideActiveClass: 'speaker--active',
    slideNextClass: 'speaker__next',
    slidePrevClass: 'speaker__prev',

    grabCursor: true,

    navigation: {
        nextEl: '.slider__item-next',
        prevEl: '.slider__item-prev',
        disabledClass: 'slider__btn--disable',
    },

    breakpoints: {
        1: {
            // Количество вывода
            slidesPerView: 1,
            // Растояние между slide
            spaceBetween: 25,
        },
        601: {
            spaceBetween: 26,
            slidesPerView: 2,
        },
        801: {
            spaceBetween: 26,
            slidesPerView: 3,
        },
        1101: {
            spaceBetween: 50,
            slidesPerView: 3,
        },
    },

    // Управление мышью/тачпад
    mousewheel: {
        sensitivity: 1,
        // Отключение вертикальной прокрутки
        forceToAxis: true,
    },

    // Перетаскивание славдов без фиксированных позиций
    freeMode: {
        enabled: false,
    },

    on: {
    },
});
